import DOMPurify from "dompurify";

/**
 * Zweiter Riegel vor dem Einsetzen von Jira-HTML (der erste ist sanitize-html
 * auf dem Server). DOMPurify lässt `target` standardmäßig nicht durch; der
 * Server setzt aber bewusst `target="_blank" rel="noopener noreferrer"` auf
 * jeden Link, damit das Cockpit im Termin nicht verlassen wird. `ADD_ATTR`
 * erhält genau dieses Attribut; `rel` bleibt ohnehin erlaubt.
 */
export function sanitizeForDisplay(html: string): string {
  return DOMPurify.sanitize(html, { ADD_ATTR: ["target"] });
}
